import { lessonTimeSchema } from '@server/schemas'
import { useTranslation } from '@shared/config/i18n'
import { z } from 'zod'

import { ChipV2, HStack } from '@podo-app/design-system-temp'

type Props = {
  selectedLessonTime: NumberEnumToStringEnum<z.infer<typeof lessonTimeSchema>>
  handleChangeLessonTime: (lessonTime: NumberEnumToStringEnum<z.infer<typeof lessonTimeSchema>>) => void
}

const SubscribeTicketLessonTimeChip = ({ selectedLessonTime, handleChangeLessonTime }: Props) => {
  const t = useTranslation()

  return (
    <HStack className="gap-2">
      <ChipV2 className="flex-1" selected={selectedLessonTime === '15'} onClick={() => handleChangeLessonTime('15')}>
        {t('subscribeList.chip.minutes', { count: 15 })}
      </ChipV2>
      <ChipV2 className="flex-1" selected={selectedLessonTime === '25'} onClick={() => handleChangeLessonTime('25')}>
        {t('subscribeList.chip.minutes', { count: 25 })}
      </ChipV2>
    </HStack>
  )
}

export default SubscribeTicketLessonTimeChip
